// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"mainWrapper__1p3wS"};